import { ADICIONAR_FILTRO_ROTA_ITINERARIO } from '../types'

export default function adicionarFiltroRotaItinerario (filtro) {
  return {
    type: ADICIONAR_FILTRO_ROTA_ITINERARIO,
    payload: filtro
  }
}
